import { Form, SubmitFormButton } from '@calendly/form';
import { useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup, Body, Footer } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { selectById, useFetchCalendarAccountsQuery, useUpdateCalendarAccountMutation } from 'features/calendar_connections/api';
import { CalendarLabel, InverseSection } from '../elements';
import { PullCalendars } from './pull_calendars';
import { UnavailableStatuses } from './unavailable_statuses';
const topSectionCss = "tx80hdw";
const TopSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(topSectionCss, props.className)} />;
});
export const PullPopup = ({
  id,
  isOpen,
  onDismiss
}) => {
  const {
    data
  } = useFetchCalendarAccountsQuery();
  const {
    kind,
    identifier,
    pullCalendarIds,
    unavailableStatuses
  } = selectById(data, id);
  const [updateAccount, {
    isSuccess
  }] = useUpdateCalendarAccountMutation();
  useOnValueChange(isSuccess, () => {
    if (isSuccess) {
      onDismiss();
    }
  });
  if (!isOpen) return null;
  const onSubmit = values => updateAccount({
    id,
    pullCalendarIds: values.pullCalendarIds,
    unavailableStatuses: values.unavailableStatuses
  });
  const initialValues = {
    pullCalendarIds,
    unavailableStatuses
  };
  return <Popup isOpen onClose={onDismiss} title={I18n.t('publisher.calendar.configuration.pull.popup.title')}>
      <Form initialValues={initialValues} onSubmit={onSubmit}>
        <Body>
          <TopSection>
            <CalendarLabel identifier={identifier} kind={kind} />
          </TopSection>
          <InverseSection>
            <UnavailableStatuses id={id} />
            <PullCalendars id={id} />
          </InverseSection>
        </Body>
        <Footer>
          <Button decoration="secondary-outline" onClick={onDismiss}>
            {I18n.t('publisher.action.cancel')}
          </Button>
          <SubmitFormButton>{I18n.t('publisher.action.update')}</SubmitFormButton>
        </Footer>
      </Form>
    </Popup>;
};

require("./pull_popup.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pull_popup.js");